export const BRAND_LIMIT_SEARCH = 'brandLimitSearch';
export const BRAND_LIMIT_GET = 'brandLimitGet';
export const BRAND_LIMIT_ADD = 'brandLimitAdd';
export const BRAND_LIMIT_ADD_OFFER = 'brandLimitAddOffer';
export const BRAND_LIMIT_REMOVE_OFFER = 'brandLimitRemoveOffer';
export const BRAND_LIMIT_REQUESTAPPROVAL = 'brandLimitRequestApproval';
export const BRAND_LIMIT_APPROVE = 'brandLimitApprove';
export const BRAND_LIMIT_DENY = 'brandLimitDeny';
export const BRAND_LIMIT_PUBLISH = 'brandLimitPublish';
export const BRAND_LIMIT_CANCEL = 'brandLimitCancel';
export const BRAND_LIMIT_SAVE = 'brandLimitSave';
export const BRAND_LIMIT_CREATE = 'brandLimitCreate';



// WEBPACK FOOTER //
// ./src/store/brand-limit/actions.type.js